import { FC } from 'react';

import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  Content,
  DocumentsTable,
  DocumentsTableProps,
  SkeletonTable,
  Title,
} from 'modules/account/common/components';

export interface DocumentsViewProps extends DocumentsTableProps {
  loading?: boolean;
}

export const DocumentsView: FC<DocumentsViewProps> = ({
  loading,
  ...tableProps
}) => {
  const { t } = useTranslation();

  return (
    <Content>
      <Stack spacing={32}>
        <Title title={t('account.documents.title')} />
        {loading ? <SkeletonTable /> : <DocumentsTable {...tableProps} />}
      </Stack>
    </Content>
  );
};
